/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader.ts";

function getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderUrl(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams["financialPersonId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/header` as const,
  };
  return res;
}

/**
 * @description Retorna dados do aluno/terceiro, curso, totais (transferências, matrícula, pago), valor líquido com descontos (cupom, empresa, pontualidade, indicação), valor com bolsa, cartão mascarado, descontos ativos e validações de consistência. Os enums do plano vêm com o texto traduzido na cultura da requisição: 'typeText' (tipo), 'statusText' (status) e 'paymentTypeText' (método de pagamento). 404 quando o plano não existe ou a empresa do usuário difere da matrícula. Migrado do legado IndividualPayment/Parcels (GetParcelsGridDetail). **(Requer Authorization para autenticação)**
 * @summary Retorna o cabeçalho da tela de parcelas do plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/header}
 */
export async function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader404
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeaderUrl(
      financialPersonId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
